enum CategoryEnum {
  Alcohol = 'Alcohol',
  Nutrition = 'Nutrition',
  Stress = 'Stress',
  Coffee = 'Coffee',
  Exercise = 'Exersize',
  Weight = 'Weight',
  Vitals = 'Vitals',
  Sleep = 'Sleep',
  Smoking = 'Smoking',
  Cholesterol = 'Cholesterol',
}

export default CategoryEnum;
